import angular from 'angular';
import {map} from 'lodash';
import 'angular-ui-router';
import template from './segmentsForm.jade';

export class SegmentsFormController {
  /* @ngInject */
  constructor($filter, currentUser) {
    this.currentUser = currentUser;
    this.translate = $filter('translate');
    this.fields = [
      {
        className: 'layout__item u-6/8',
        type: 'input',
        key: 'name',
        expressionProperties: {
          "templateOptions.label": "'name' | translate"
        },
        hideExpression: function($viewValue, $modelValue, scope) {
          return scope.$parent.vm.portion !== 'top';
        },
        templateOptions: {
          label: '',
          required: true
        }
      },
      {
        className: 'layout__item u-1/8 c-switch--single',
        type: 'radioSwitch',
        key: 'status',
        defaultValue: 'active',
        hideExpression: function($viewValue, $modelValue, scope) {
          return scope.$parent.vm.portion !== 'top';
        },
        templateOptions: {
          label: this.translate('status'),
          required: true,
          options: [
            {
              name: this.translate('active'),
              value: 'active'
            },
            {
              name: this.translate('paused'),
              value: 'paused'
            }
          ],
          tooltipText: this.translate('status')
        }
      },
      {
        className: 'layout__item u-1/8',
        expressionProperties: {
          "templateOptions.label": "'CTV' | translate"
        },
        type: 'checkbox',
        key: 'isCtv',
      },
      {
        className: 'c-switches-layout__item tableize u-pv',
        hideExpression: () => {
          return !(this.resource.type == 'for_sale' && this.portion == 'switches');
        },
        fieldGroup: [
          {
            className: 'tableize__cell tableize__cell--fill u-pr--',
            type: 'money',
            key: 'floor_price',
            templateOptions: {
              label: this.translate('player_floor_price'),
              currency: 'USD ($)'
            },
            extras: {validateOnModelChange: true},
            validators: {
              twoDecimalDigits: {
                expression: function($viewValue, $modelValue, scope) {
                  let value = $modelValue || $viewValue;
                  let reg = /^[0-9]+(\.[0-9]{1,2})?$/;
                  return reg.test(value);
                }
              }
            }
          }
          //{
          //  className: 'tableize__cell text-right c-switch--single',
          //  type: 'radioSwitch',
          //  key: 'floor_price_type',
          //  templateOptions: {
          //    label: '&nbsp;',
          //    options: [
          //      {
          //        name: this.translate('soft'),
          //        value: 'soft'
          //      },
          //      {
          //        name: this.translate('hard'),
          //        value: 'hard'
          //      }
          //    ]
          //  }
          //}
        ]
      },
      {
        className: 'c-switches-layout__item c-switch--single',
        type: 'labeledRadioSwitch',
        key: 'anonymous',
        defaultValue: true,
        hideExpression: function($viewValue, $modelValue, scope) {
          return scope.$parent.vm.resource.type !== 'for_sale' || scope.$parent.vm.portion !== 'switches';
        },
        templateOptions: {
          label: this.translate('anonymous'),
          required: true,
          options: [
            {
              name: this.translate('active'),
              value: true
            },
            {
              name: this.translate('inactive'),
              value: false
            }
          ],
          tooltipText: this.translate('anonymous')
        }
      },
      //{
      //  className: 'c-switches-layout__item c-switch--single',
      //  type: 'labeledRadioSwitch',
      //  key: 'show_payment_amount',
      //  defaultValue: false,
      //  hideExpression: function($viewValue, $modelValue, scope) {
      //    return scope.$parent.vm.resource.type !== 'for_sale' || scope.$parent.vm.portion !== 'switches';
      //  },
      //  templateOptions: {
      //    label: this.translate('show_payment_amounts'),
      //    required: true,
      //    options: [
      //      {
      //        name: this.translate('active'),
      //        value: true
      //      },
      //      {
      //        name: this.translate('inactive'),
      //        value: false
      //      }
      //    ],
      //    tooltipText: this.translate('show_payment_amounts')
      //  }
      //},
      {
        className: 'c-switches-layout__item c-switch--single ng-hide',
        type: 'labeledRadioSwitch',
        key: 'private_marketplace',
        defaultValue: false,
        hideExpression: function($viewValue, $modelValue, scope) {
          return scope.$parent.vm.resource.type !== 'for_sale' || scope.$parent.vm.portion !== 'switches';
        },
        templateOptions: {
          label: this.translate('private_marketplace'),
          required: true,
          options: [
            {
              name: this.translate('active'),
              value: true
            },
            {
              name: this.translate('inactive'),
              value: false
            }
          ],
          tooltipText: this.translate('private_marketplace')
        }
      },
      {
        className: 'layout__item u-1/4 ng-hide',
        type: 'input',
        key: 'number_of_buyers',
        expressionProperties: {
          "templateOptions.label": "'number_of_buyers' | translate"
        },
        hideExpression: function($viewValue, $modelValue, scope) {
          return scope.$parent.vm.resource.type !== 'for_sale' || scope.$parent.vm.portion !== 'bottom';
        },
        templateOptions: {
          label: '',
          required: false
        }
      },
      {
        className: 'layout__item u-3/4 ng-hide',
        type: 'input',
        key: 'blacklist_gds',
        expressionProperties: {
          "templateOptions.label": "'blacklist_gds' | translate"
        },
        hideExpression: function($viewValue, $modelValue, scope) {
          return scope.$parent.vm.resource.type !== 'for_sale' || scope.$parent.vm.portion !== 'bottom';
        },
        templateOptions: {
          label: '',
          required: false
        }
      }
    ]

    this.fields = map(this.fields, ({className, ...rest}) => ({
      className: this.withDisabledClassName(className),
      ...rest
    }))
  }

  withDisabledClassName(className) {
    return this.currentUser.value.hasRole(['AGENCY','GD_ACCOUNT_MANAGER', 'GG_ACCOUNT_MANAGER']) ? `${className} disabled-by-role` : className;
  };
}

export function SegmentsFormComponent() {
  return {
    template,
    controller: SegmentsFormController,
    restrict: 'E',
    controllerAs: 'vm',
    scope: {
      resource: '=',
      portion: '@?'
    },
    bindToController: true
  };
};

export default angular.module('app.components.segments.form', [])
  .directive('segmentsForm', SegmentsFormComponent);



/** WEBPACK FOOTER **
 ** ./src/components/segments/segmentsForm.js
 **/